import React, {Component} from 'react';
import ContactProfileCard from './ContactProfileCard';
import Utils from '../utils';
import Constants from '../constants';
import SlickSlider from 'react-slick';


class ContactsWrapper extends Component{


    getCurrentContacts(){
        let contactsByRegion =  Utils.filterDataByProp(this.props.apiData.region_contacts , 'region',  this.props.currentRegion);
        //let location =  Utils.filterDataByProp(filteredByRegion , 'location',  this.props.currentLocation);
        return contactsByRegion;  
    }

    render(){
        const slickSettings = {
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        const contacts =  this.props.currentRegion ? this.getCurrentContacts() : Constants.defaultContacts ;
        return(
        <div className="module module--large module--brand" id="get-in-touch">
            <h2 className="text-center gutter">Key contacts</h2>
            <div className="row">
                <SlickSlider className="get-in-touch-carousel" {...slickSettings}>
                    {contacts.map((contact , i)=>{
                        return <div className="contact-profile" key={'contact-' + i}><ContactProfileCard {...this.props} contact={contact}  /></div>
                    })}
                </SlickSlider>
            </div>
        </div>
        )
    }
}

export default ContactsWrapper;


// WEBPACK FOOTER //
// ./src/js/components/ContactsWrapper.js